var map = {
	"./decidim/avatar-multiuser.png": 92697,
	"./decidim/brands/facebook.svg": 74157,
	"./decidim/brands/google.svg": 66964,
	"./decidim/brands/twitter-x.svg": 73969,
	"./decidim/cc-badge.png": 78799,
	"./decidim/decidim-logo.svg": 87915,
	"./decidim/default-avatar.svg": 65679,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 42293,
	"./decidim/icons.svg": 31502,
	"./decidim/pattern.png": 9693,
	"./decidim/placeholder-card-g.svg": 57490,
	"./decidim/placeholder-card-l.svg": 96121,
	"./decidim/placeholder.jpg": 24616,
	"./decidim/remixicon.symbol.svg": 81002,
	"./decidim/vendor/social-share-button/douban.svg": 18221,
	"./decidim/vendor/social-share-button/email.svg": 97358,
	"./decidim/vendor/social-share-button/facebook.svg": 81734,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 36170,
	"./decidim/vendor/social-share-button/hacker_news.svg": 46494,
	"./decidim/vendor/social-share-button/linkedin.svg": 92996,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 34557,
	"./decidim/vendor/social-share-button/pinterest.svg": 98616,
	"./decidim/vendor/social-share-button/reddit.svg": 50290,
	"./decidim/vendor/social-share-button/telegram.svg": 39859,
	"./decidim/vendor/social-share-button/tumblr.svg": 46256,
	"./decidim/vendor/social-share-button/twitter.svg": 41331,
	"./decidim/vendor/social-share-button/vkontakte.svg": 92249,
	"./decidim/vendor/social-share-button/wechat.svg": 3468,
	"./decidim/vendor/social-share-button/whatsapp.svg": 67588,
	"./decidim/vendor/social-share-button/x.svg": 36918,
	"./decidim/vendor/social-share-button/xing.svg": 41666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98610;